<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <v-form id="form" v-model="isValid">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4">
                <v-autocomplete
                  :label="$i18n.t('Content Type1')"
                  v-model="content.contentType"
                  :items="contentTypes"
                  :disabled="isEdit"
                  item-text="value"
                  item-value="value"
                  autocomplete="off"
                />
              </v-col>

              <v-col cols="12" sm="12" md="4" lg="4">
                <z-entity-select
                  :label="$i18n.t('Entity')"
                  v-model="content.entity_id"
                  :corp="webcontent.adminOf"
                />
              </v-col>

              <v-col cols="12" sm="12" md="4" lg="4">
                <z-language-select
                  :label="$i18n.t('Language')"
                  v-model="content.lang"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <vue-editor v-model="text"></vue-editor>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="text-right">
            <v-btn
              color="green"
              class="mr-0"
              v-on:click="saveContent()"
              :loading="loading"
            >
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";
import { VueEditor } from "vue2-editor";

@Component({
  name: "StaticContentEdit",
  components: {
    VueEditor,
  },
  props: {
    payload: {
      default: {},
    },
    contentDialog: {
      default: null,
    },
  },
})
export default class StaticContentEdit extends Vue {
  isValid = true;
  isEdit = false;
  file = null;
  content_id = null;
  webcontent = {};
  contentTypes = [];
  text = null;
  content = {
    businessUnit_id: null,
    content: null,
    contentType: null,
    desc: null,
    lang: null,
  };

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  get loading() {
    return common.loading;
  }

  async fetchContents() {
    this.contentTypes = await doGet("/api/admin/contents");
  }

  async saveContent() {
    try {
      common.setLoading(true);
      let url_post;
      if (this.isEdit) {
        url_post = "/api/content/" + this.content_id + "/edit";
      } else {
        url_post = "/api/content/new";
      }
      this.content.content = this.text;
      const content = await doPost(url_post, this.content);
      if (this.payload && this.payload.fromDialog) {
        this.$emit("fetchContent", true);
        this.$emit("contentDialog", false);
      } else {
        if (!this.content_id)
          this.$router.push("/staticcontent/" + content._id);
        this.content_id = content._id;
        this.get();
        common.showMessage("Saved Successfully");
      }
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchDetail(_content) {
    if (!_content) _content = {};
    if (!_content.businessUnit_id) _content.businessUnit_id = null;
    if (!_content.content) _content.content = null;
    if (!_content.contentType) _content.contentType = null;
    if (!_content.desc) _content.desc = null;
    if (!_content.lang) _content.lang = null;
  }

  async get() {
    try {
      const content = await doGet(
        "/api/content/" + this.content_id + "/detail"
      );
      this.postFetchDetail(content);
      this.content = content;
      this.content_id = this.content._id;
      this.isEdit = true;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async getSavedContent(_contentType) {
    const content = await doGet("/api/static/content/detail/" + _contentType);
    this.postFetchDetail(content);
    if (content) {
      this.content = content;
      if (!this.content.contentType) {
        this.content.contentType = _contentType;
      }
      this.text = this.content.content;
      this.content_id = this.content._id;
      this.isEdit = this.content._id ? true : null;
    }
  }

  async mounted() {
    await auth.doPostLogin();

    this.webcontent = auth.authContent;
    await this.fetchContents();

    if (this.payload && this.payload.fromDialog) {
      if (this.payload.contentType) {
        await this.getSavedContent(this.payload.contentType);
      }
    } else {
      if (this.$route.params.id) {
        this.content_id = this.$route.params.id;
        await this.get();
      }
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }
}
</script>
<style scoped>
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
</style>
